import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'

// ADD this import for the new component we will create
import RegionViewer from '@/views/RegionViewer.vue'

const routes = [
  {
    path: '/variant/:id',
    name: 'Charts', // This is your Main.vue
    component: () => import(/* webpackChunkName: "about" */ '@/views/Main.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // --- ADD THIS NEW ROUTE ---
  {
    path: '/region/:geneId',
    name: 'RegionViewer',
    component: RegionViewer, // Use the imported component
    meta: {
      requiresAuth: true
    }
  },
  // --- END OF ADDED ROUTE ---
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "about" */ '@/views/Contact.vue'),
  },
  {
    path: "/FAQ",
    name: "FAW", // Note: Typo in original file? Maybe FAQ?
    component: () => import(/* webpackChunkName: "about" */ '@/views/FAQ.vue'),
  },
  {
    path: '/',
    name: 'Pre', // This is your search/landing page
    component: () => import(/* webpackChunkName: "about" */ '@/views/Pre.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: () => import(/* webpackChunkName: "about" */ '@/views/NotFound.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    next()
  } else next()
})
export default router